import { useContext, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import userPlaceholder from "../../assets/images/users/user-vector.png";
import appLogo from "../../assets/icons/appicon.png";

import { FaRegBell } from "react-icons/fa";

import { UserContext } from "../../storage/contexts/UserContext";
import UserProfileModal from "../../InterstellrModals/UserProfileModal";
import { GET_USER_PROFILE } from "../../Routes";
import axios from "axios";
import { generateURLOptions } from "../../URLOptions";
import EventBus from "../../storage/EventBus";

import { HiMenuAlt3 } from "react-icons/hi";
import UserResetPasswordModal from "../../InterstellrModals/UserResetPasswordModal";
import UserSupportPersonModal from "../../InterstellrModals/UserSupportPeopleModal";
import AddSupportPersonModal from "../../InterstellrModals/AddSupportPersonModal";
import UserManageTeamModal from "../../InterstellrModals/UserManageTeamModal";

const CommonHeader = () => {
  const { profile, setProfile } = useContext(UserContext);
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);

  const [profileOpen, setProfileOpen] = useState(false);
  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
  const [supportPeopleOpen, setSupportPeopleOpen] = useState(false);
  const [manageTeamOpen, setManageTeamOpen] = useState(false);
  const [addSupportOpen, setAddSupportOpen] = useState(false);

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const checkLogin = async () => {
    const token = localStorage.getItem("accessToken");
    console.log("USER TOKEN IS: ", token);

    const userType = localStorage.getItem("userType");
    console.log("USER TYPE IS: ", userType);

    if (!token || !userType) {
      logout();
    } else {
      updateUserProfile();
      if (userType == 3 || userType == 4) {
        return navigate("/organisation/pulse");
      }

      return navigate("/dashboard");
    }
  };

  const updateUserProfile = async () => {
    try {
      const response = await axios.post(
        GET_USER_PROFILE,
        {},
        {
          headers: generateURLOptions(),
        },
      );

      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      setProfile(response.data.data);
    } catch (error) {
      if (error.response.status == 401) {
        return logout();
      }
      return alert(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      checkLogin();
    }, 350);
    EventBus.on("updateProfile", updateUserProfile);

    return () => EventBus.off("updateProfile", updateUserProfile);
  }, []);

  return (
    <>
      <UserProfileModal
        isOpen={profileOpen}
        onClose={() => setProfileOpen(false)}
        onChangePassword={() => {
          setProfileOpen(false);
          setResetPasswordOpen(true);
        }}
        onSupportPeople={() => {
          setProfileOpen(false);
          setTimeout(() => {
            setSupportPeopleOpen(true);
          }, 250);
        }}
        onManageTeam={() => {
          setProfileOpen(false);
          setTimeout(() => {
            setManageTeamOpen(true);
          }, 250);
        }}
        onLogout={() => {
          setProfileOpen(false);
          logout();
        }}
      />

      <UserResetPasswordModal
        isOpen={resetPasswordOpen}
        onClose={() => setResetPasswordOpen(false)}
        person={profile}
        onUpdate={() => {
          setResetPasswordOpen(false);
          logout();
        }}
      />

      <UserSupportPersonModal
        isOpen={supportPeopleOpen}
        onClose={() => setSupportPeopleOpen(false)}
        onAddPerson={() => {
          setTimeout(() => {
            setAddSupportOpen(true);
          }, 250);
        }}
      />

      <UserManageTeamModal
        isOpen={manageTeamOpen}
        onClose={() => setManageTeamOpen(false)}
      />

      <AddSupportPersonModal
        isOpen={addSupportOpen}
        onClose={() => setAddSupportOpen(false)}
        onUpdate={() => {
          setAddSupportOpen(false);
          updateUserProfile();
        }}
      />

      <header className="flex flex-row justify-center items-center container mx-auto w-full">
        {/* Mind Pulse Logo */}
        <Link
          className="w-24 h-auto"
          to={
            profile?.usertype == 3 || profile?.usertype == 4
              ? "/organisation/pulse"
              : "/dashboard"
          }
        >
          <img
            className="w-24 h-auto object-contain"
            src={appLogo}
            alt={"Mind Pulse"}
          />
        </Link>

        <div style={{ flex: 1 }} />

        {/* Menu Area */}
        {/* Adjust Menu Items based on usertype */}
        {profile?.usertype !== 3 && profile?.usertype !== 4 ? (
          <>
            <div className="hidden md:flex flex-row justify-center items-center">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-mpPurple font-semibold text-sm mr-4"
                    : "text-black font-normal text-sm mr-4"
                }
                to="/mood/capture"
              >
                <p>Daily Mood Capture</p>
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-mpPurple font-semibold text-sm mr-4"
                    : "text-black font-normal text-sm mr-4"
                }
                to="/wellness"
              >
                <p>Wellness</p>
              </NavLink>

              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-mpPurple font-semibold text-sm mr-4"
                    : "text-black font-normal text-sm mr-4"
                }
                to="/calendar/mood"
              >
                <p>Mood Calendar</p>
              </NavLink>

              {profile?.usertype == 1 && profile?.schoolMode == false ? (
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "text-mpPurple font-semibold text-sm mr-4"
                      : "text-black font-normal text-sm mr-4"
                  }
                  to="/people/calendar"
                >
                  <p>People Calendar</p>
                </NavLink>
              ) : null}

              <NavLink
                to="/questionnaires"
                className={({ isActive }) =>
                  isActive
                    ? "text-mpPurple font-semibold text-sm mr-4"
                    : "text-black font-normal text-sm"
                }
              >
                <p>Questionnaires</p>
              </NavLink>
            </div>
          </>
        ) : (
          <>
            <div className="hidden md:flex flex-row justify-center items-center">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-mpPurple font-semibold text-sm mr-4"
                    : "text-black font-normal text-sm mr-4"
                }
                to="/organisation/pulse"
              >
                <p>Organisational Pulse</p>
              </NavLink>
              {profile?.usertype == 3 ? (
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "text-mpPurple font-semibold text-sm mr-4"
                      : "text-black font-normal text-sm mr-4"
                  }
                  to="/manager/questionnaires"
                >
                  <p>Questionnaires</p>
                </NavLink>
              ) : null}

              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-mpPurple font-semibold text-sm mr-4"
                    : "text-black font-normal text-sm mr-4"
                }
                to="/organisation/people"
              >
                <p>People Directory</p>
              </NavLink>

              {profile?.usertype == 3 ? (
                <NavLink
                  to="/organisation/configurator"
                  className={({ isActive }) =>
                    isActive
                      ? "text-mpPurple font-semibold text-sm mr-4"
                      : "text-black font-normal text-sm"
                  }
                >
                  <p>Organisation Configurator</p>
                </NavLink>
              ) : null}
            </div>
          </>
        )}

        <div style={{ flex: 1 }} />

        {/* Notifications */}
        <Link className="mr-4" to={"/employee/notifications"}>
          <FaRegBell fontSize={24} />
        </Link>

        {/* User Profile */}
        <div className="flex flex-row justify-center items-center">
          <div className="flex flex-row justify-center items-center">
            <div
              className="cursor-pointer flex flex-row justify-center items-center mr-4 md:mr-0"
              onClick={() => setProfileOpen(true)}
            >
              <img
                src={profile?.profileImage ?? userPlaceholder}
                className="w-8 h-8 object-cover rounded-full"
                alt={profile?.firstname ?? ""}
              />

              <p className="hidden md:block ml-2 font-medium text-base">
                {profile?.firstname ?? ""}
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Menu Icon */}
        <div className="relative md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="mt-1 mr-4">
            <HiMenuAlt3 fontSize={24} />
          </button>

          {menuOpen && (
            <div className="fixed inset-x-0 top-20 bg-white z-50 border-t shadow-md">
              <div className="flex flex-col">
                {profile?.usertype !== 3 && profile?.usertype !== 4 ? (
                  <>
                    <NavLink
                      to="/mood/capture"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      Daily Mood Capture
                    </NavLink>
                    <NavLink
                      to="/wellness"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      Wellness
                    </NavLink>
                    <NavLink
                      to="/calendar/mood"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      Mood Calendar
                    </NavLink>
                    <NavLink
                      to="/questionnaires"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      Questionnaires
                    </NavLink>
                  </>
                ) : (
                  <>
                    <NavLink
                      to="/organisation/pulse"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      Organisational Pulse
                    </NavLink>
                    <NavLink
                      to="/manager/questionnaires"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      Questionnaires
                    </NavLink>
                    <NavLink
                      to="/organisation/people"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      People Directory
                    </NavLink>
                    <NavLink
                      to="/organisation/people/calendar"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      People Calendar
                    </NavLink>
                    <NavLink
                      to="/organisation/configurator"
                      className={({ isActive }) =>
                        `px-6 py-4 text-sm font-medium ${
                          isActive ? "bg-mpPurple text-white" : "text-gray-800"
                        } hover:bg-gray-100`
                      }
                      onClick={() => setMenuOpen(false)}
                    >
                      Organisation Configurator
                    </NavLink>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default CommonHeader;
